var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:{active: _vm.active, 'link-black': !_vm.isSeguindo},on:{"click":() => _vm.isSeguindo ? _vm.unfollow() : _vm.follow()}},[_c('u-icon',{staticClass:"m-r-xs",attrs:{"name":"bell","type":"fa"}}),(!_vm.isSeguindo)?_c('span',[_vm._v("Seguir tarefa")]):_c('span',[_vm._v("Seguindo")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }